import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e83a8c56&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83a8c56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e83a8c56')) {
      api.createRecord('e83a8c56', component.options)
    } else {
      api.reload('e83a8c56', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e83a8c56&scoped=true&", function () {
      api.rerender('e83a8c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/codingSet/index.vue"
export default component.exports